import React, { useEffect } from 'react';
import { theme } from '@citygross/design-tokens';
import { BasePrimaryButton, Loading, LoadingContainer, LoadingSpinner, ButtonChildContainer, IconWrapper, IconContainer } from './Button.styles.js';
import { BodyText } from '@citygross/typography';

function SaveButton(_a) {
  var _b, _c;

  var beforeSaveText = _a.beforeSaveText,
      afterSaveText = _a.afterSaveText,
      _d = _a.onSavedColor,
      onSavedColor = _d === void 0 ? 'alertGreen' : _d,
      _e = _a.size,
      size = _e === void 0 ? 'large' : _e,
      xsSize = _a.xsSize,
      icon = _a.icon,
      isDisabled = _a.isDisabled,
      loading = _a.loading,
      noWrap = _a.noWrap,
      onClick = _a.onClick,
      fullWidth = _a.fullWidth,
      _f = _a.childGap,
      childGap = _f === void 0 ? 4 : _f,
      saved = _a.saved,
      _g = _a.color,
      color = _g === void 0 ? (_c = (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.secondary) !== null && _c !== void 0 ? _c : '' : _g,
      onAnimationComplete = _a.onAnimationComplete;
  useEffect(function () {
    var _a;

    if (!loading && saved) {
      setTimeout(function () {
        onAnimationComplete();
      }, (_a = theme === null || theme === void 0 ? void 0 : theme.animations) === null || _a === void 0 ? void 0 : _a.saveButtonAnimationComplete);
    }
  }, [saved]);
  return React.createElement(BasePrimaryButton, {
    color: saved ? onSavedColor : color,
    isDisabled: loading || isDisabled,
    loading: loading || null,
    size: size,
    fullWidth: fullWidth,
    icon: icon,
    noWrap: noWrap,
    onClick: saved ? function () {} : function (e) {
      return onClick(e);
    }
  }, loading && React.createElement(Loading, null, React.createElement(LoadingContainer, {
    xsSize: xsSize,
    size: size
  }, React.createElement(LoadingSpinner, null))), React.createElement(ButtonChildContainer, {
    size: size,
    noWrap: noWrap,
    childGap: childGap
  }, saved ? React.createElement(React.Fragment, null, icon && React.createElement(IconWrapper, null, React.createElement(IconContainer, null, icon)), React.createElement(BodyText, {
    color: "white"
  }, afterSaveText)) : React.createElement(BodyText, {
    color: "white"
  }, beforeSaveText)));
}

export { SaveButton };